// extracted by mini-css-extract-plugin
export default {"cls1":"QVd84rxAU61WqAbTGFe0","cls2":"En4akCUZbPxLsqU3p9Ds QVd84rxAU61WqAbTGFe0"};